import React, { FC } from 'react';
import Label from '../../atoms/Label';
import { PiCaretUpFill, PiCaretDownFill } from 'react-icons/pi';

interface SortableLabelProps {
  content?: string;
  onClick?: () => void;
  sortDirection?: 'asc' | 'desc' | null;
}

const SortableLabel: FC<SortableLabelProps> = ({
  content = '',
  onClick,
  sortDirection,
}) => {
  return (
    <>
      <Label bold content={content} noBreak></Label>
      <button className="btn btn-link p-0" onClick={onClick}>
        {sortDirection === 'asc' ? (
          <PiCaretUpFill color="black" />
        ) : sortDirection === 'desc' ? (
          <PiCaretDownFill color="black" />
        ) : (
          <PiCaretUpFill color="black" style={{ opacity: 0.3 }} />
        )}
      </button>
    </>
  );
};

export default SortableLabel;
